import React from "react";
import { Link } from "react-router-dom";
export default function NotFound() {
    return (
        <section className="relative py-[40px] h-[100vh] overflow-hidden">
            <div className="container h-full flex gap-[50px] justify-between">
                <div className="w-full flex flex-col items-center text-center justify-center gap-[50px]">
                    <div className="flex flex-col items-center text-center justify-center">
                        <div className="text-[250px] font-bold text-[#0B2C3D] h-[310px]">404</div>
                        <div className="text-[#0B2C3D] text-[45px] font-bold">Page Not Found</div>
                    </div>
                    <Link to={"/"} className="py-[10px] px-[30px] text-white font-bold capitalize bg-[#0B2C3D] rounded-[4px]">Go Back</Link>
                </div>
            </div>
        </section>
    );
}